import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config as variantConfig } from '@/pageConfig/pet/pet/us/bottom-sticky-cta';
import { PetPageTemplate } from '@/pageTemplate/PetPageTemplate';
import { useEffect } from 'react';

export default function PetPage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();

  useEffect(
    () =>
      trackEventWithGeolocation('pet_landing_page.viewed', {
        experiment: 'bottom_sticky_cta_on',
      }),
    [],
  );

  return <PetPageTemplate config={variantConfig} />;
}
